import request from '@/utils/request'

// ATG-模板小组管理(后台接口)---------------------------------------------------------------------------------
// 关联版式
export function templateGroupTemplateGroupRelateLayout (val) {
  return request({
    url: '/api/pms/admin/template/group/templateGroupRelateLayout', // 接口
    method: 'post', // 请求方式
    data: val
  })
}

// 取消关联版式
export function templateGroupCancelRelateLayout (val) {
  return request({
    url: '/api/pms/admin/template/group/cancelRelateLayout', // 接口
    method: 'post', // 请求方式
    data: val
  })
}

// 查看设计版
export function getTemplateGroupByModuleId (val) {
  return request({
    url: `/api/pms/admin/template/group/getTemplateGroupByModuleId/${val}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 编辑设计版
export function templateGroupRelation (val) {
  return request({
    url: '/api/pms/admin/template/group/relation', // 接口
    method: 'post', // 请求方式
    data: val
  })
}

// 设为默认
export function templateGroupSetDefaultModule (val) {
  return request({
    url: `/api/pms/admin/template/group/setDefaultModule/${val}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 审核
export function templateGroupAuditTemplateGroup (val) {
  return request({
    url: '/api/pms/admin/template/group/auditTemplateGroup', // 接口
    method: 'post', // 请求方式
    data: val
  })
}

// 删除
export function templateGroupBatchRemove (val) {
  return request({
    url: '/api/pms/admin/template/group/batchRemove', // 接口
    method: 'post', // 请求方式
    data: val
  })
}

// 分页列表
export function templateGroupGetTemplateGroupList (val) {
  return request({
    url: `/api/pms/admin/template/group/getTemplateGroupList/${val.pageNum}/${val.pageSize}`, // 接口
    method: 'post', // 请求方式
    data: val.searchTemplateVo
  })
}

// 详情
export function templateGroupQueryTemplateGroupById (val) {
  return request({
    url: `/api/pms/admin/template/group/queryTemplateGroupById/${val}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 线上产品管理(后台接口)-------------------------------------------------------------
// 添加产品
export function posSpuAdd (val) {
  return request({
    url: '/api/pms/admin/pos/spu/add', // 接口
    method: 'post', // 请求方式
    data: val
  })
}
export function posSpuUpdate (val) {
  return request({
    url: '/api/pms/admin/pos/spu/update', // 接口
    method: 'post', // 请求方式
    data: val
  })
}

// 线上产品管理-产品-详情
export function prodductInfo (val) {
  return request({
    url: `/api/pms/admin/pos/spu/get/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function getSku (val) {
  return request({
    url: `/api/pms/pos/sku/list/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 线上产品管理-产品-删除
export function deleteSpu (val) {
  return request({
    url: `/api/pms/admin/pos/spu/${val}`, // 接口
    method: 'delete', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 分页列表
export function posSpuList (val) {
  return request({
    url: `/api/pms/admin/pos/spu/list/${val.pageNum}/${val.pageSize}`, // 接口
    method: 'post', // 请求方式
    data: val.spuVO
  })
}

// 线上产品类管理(后台接口)-------------------------------------------------------
// 新增
export function posCategoryAdd (val) {
  return request({
    url: '/api/pms/admin/pos/category/add', // 接口
    method: 'post', // 请求方式
    data: val
  })
}

// 更新
export function posCategoryUpdate (val) {
  return request({
    url: `/api/pms/admin/pos/category/update/${val.categoryId}`, // 接口
    method: 'put', // 请求方式
    data: val.data
  })
}

// 列表
export function posCategoryList (val) {
  return request({
    url: `/api/pms/admin/pos/category/list/${val.tagsId}`, // 接口
    method: 'get', // 请求方式
    params: { categoryName: val.categoryName },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 查询所有子类
export function posCategoryQueryAllSubs (val) {
  return request({
    url: `/api/pms/admin/pos/category/queryAllSubs/${val}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 线上产品库管理(后台接口)------------------------------------------------------
// 新增
export function posTagsAdd (val) {
  return request({
    url: '/api/pms/admin/pos/tags/add', // 接口
    method: 'post', // 请求方式
    data: val
  })
}
// 编辑
export function posTagsUpdate (val) {
  return request({
    url: '/api/pms/admin/pos/tags/update', // 接口
    method: 'put', // 请求方式
    data: val
  })
}
// 分页列表
export function posTagsGetTagsList (val) {
  return request({
    url: `/api/pms/admin/pos/tags/getTagsList/${val.pageNum}/${val.pageSize}`, // 接口
    method: 'post', // 请求方式
    data: val.data
  })
}
// 删除
export function posTagsDelete (val) {
  return request({
    url: `/api/pms/admin/pos/tags/delete/${val}`, // 接口
    method: 'delete', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// A-Sku满减管理--------------------------------------------------------
// 新增(批量)
export function skuDiscountRuleAddBatch (val) {
  return request({
    url: '/api/pms/admin/sku/discount/rule/addBatch', // 接口
    method: 'post', // 请求方式
    data: val
  })
}

// 删除
export function skuDiscountRuleDelete (val) {
  return request({
    url: `/api/pms/admin/sku/discount/rule/delete/${val}`, // 接口
    method: 'delete', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 分页列表
export function skuDiscountRuleList (val) {
  return request({
    url: `/api/pms/admin/sku/discount/rule/list/${val.pageNum}/${val.pageSize}`, // 接口
    method: 'post', // 请求方式
    data: val.data
  })
}

// 产品名称模糊查询
export function spuLikeByName (val) {
  return request({
    url: '/api/pms/admin/spu/like/by/name', // 接口
    method: 'post', // 请求方式
    params: { spuName: val }
  })
}
// Sku组名称模糊查询
export function skuGroupLikeByName (val) {
  return request({
    url: '/api/pms/admin/sku/group/like/by/name', // 接口
    method: 'post', // 请求方式
    params: { skuGroupName: val }
  })
}
// 获取单品所关联的套系
export function skuGroupListAssociateSeries (val) {
  return request({
    url: `/api/pms/admin/sku/group/list/associate/series/${val}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// Sku名称模糊查询
export function skuLikeByName (val) {
  return request({
    url: '/api/pms/admin/sku/like/by/name', // 接口
    method: 'post', // 请求方式
    params: { skuName: val }
  })
}
// Spu属性值任务号管理----------------------------------------------------------------------
// 新增
export function spuDictJobAdd (val) {
  return request({
    url: '/api/pms/admin/spu/dict/job/add',
    method: 'post',
    data: val
  })
}
// 分页列表
export function spuDictJobList (val) {
  return request({
    url: `/api/pms/admin/spu/dict/job/list/${val.pageNum}/${val.pageSize}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 删除
export function spuDictJobDelete (val) {
  return request({
    url: `/api/pms/admin/spu/dict/job/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更新
export function spuDictJobUpdate (val) {
  return request({
    url: `/api/pms/admin/spu/dict/job/update/${val.id}`,
    method: 'put',
    data: val.spuDictJobVO
  })
}
// Spu属性值管理-------------------------------------------------------------------------
// 新增
export function spuDictAttrAdd (val) {
  return request({
    url: '/api/pms/admin/spu/dict/attr/add',
    method: 'post',
    data: val
  })
}
// 删除
export function spuDictAttrDelete (val) {
  return request({
    url: `/api/pms/admin/spu/dict/attr/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 分页列表
export function spuDictAttrList (val) {
  return request({
    url: `/api/pms/admin/spu/dict/attr/list/${val.pageNum}/${val.pageSize}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更新
export function spuDictAttrUpdate (val) {
  return request({
    url: `/api/pms/admin/spu/dict/attr/update/${val.id}`,
    method: 'put',
    data: val.spuDictAttrVO
  })
}
// Sku样品主题管理----------------------------------------------------------------------
// 删除主题
export function skuSampleDelete (val) {
  return request({
    url: `/api/pms/admin/sku/sample/delete/${val.skuGroupId}/${val.themeId}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 新增主题
export function skuSampleSave (val) {
  return request({
    url: `/api/pms/admin/sku/sample/save/${val.skuGroupId}/${val.themeId}`,
    method: 'post'
  })
}
// O-类管理----------------------------------------------------------------------------
// 获取顶级类
export function openCategoryList (val) {
  return request({
    url: '/api/pms/open/category/list',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// -获取子类
export function categoryQuerySub (val) {
  return request({
    url: `/api/pms/open/category/query/sub/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 字典表-----------------------------------------------------------------------------
// 产品类型
export function spuType (val) {
  return request({
    url: `/api/pms/admin/sys/dictionary/list/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 白页位置
export function whitePosition (val) {
  return request({
    url: '/api/pms/admin/sys/dictionary/list/white/position',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 产品性质
export function spuProperty (val) {
  return request({
    url: '/api/pms/admin/sys/dictionary/list/spu/property',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 色块形状
export function blockShape (val) {
  return request({
    url: '/api/pms/admin/sys/dictionary/list/block/shape',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 背景默认项
export function elementBgFit (val) {
  return request({
    url: '/api/pms/admin/sys/dictionary/list/element/bg/fit',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 条码位置
export function barCodePosition (val) {
  return request({
    url: '/api/pms/admin/sys/dictionary/list/bar/code/position',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 元素|背景|组合管理(后台接口)--------------------------------------------------------------
// 更新（背景契合度）
export function elementUpdate (val) {
  return request({
    url: `/api/pms/admin/element/update/${val.id}`,
    method: 'put',
    params: { fitId: val.fitId },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 新增
export function elementSetAdd (val) {
  return request({
    url: '/api/pms/admin/element/add',
    method: 'post',
    data: val
  })
}
// 新增组合
export function elementAddCombo (val) {
  return request({
    url: '/api/pms/admin/element/addCombo',
    method: 'post',
    data: val
  })
}
// 删除
export function elementBatchRemove (val) {
  return request({
    url: '/api/pms/admin/element/batchRemove',
    method: 'post',
    data: val
  })
}
// 设置显示
export function elementSetShow (val) {
  return request({
    url: '/api/pms/admin/element/setShow',
    method: 'post',
    data: val
  })
}
// 分页列表
export function elementGetElementList (val) {
  return request({
    url: `/api/pms/admin/element/getElementList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.searchElementVo
  })
}
// 素材标签管理-----------------------------------------------------------------------
// 新增
export function labelAdd (val) {
  return request({
    url: '/api/pms/admin/label/add',
    method: 'post',
    data: val
  })
}
// 编辑标签
export function labelUpdate (val) {
  return request({
    url: '/api/pms/admin/label/update',
    method: 'put',
    data: val
  })
}
// 删除
export function labelBatchRemove (val) {
  return request({
    url: '/api/pms/admin/label/batchRemove',
    method: 'post',
    data: val
  })
}
// 分页列表
export function labelGetLabelList (val) {
  return request({
    url: `/api/pms/admin/label/getLabelList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.searchLabelVo
  })
}
// 白页管理--------------------------------------------------------------------------
// 名称可用
export function whitePageUsable (val) {
  return request({
    url: '/api/pms/admin/white/page/usable',
    method: 'post',
    params: val
  })
}
// 删除
export function whitePageDelete (val) {
  return request({
    url: `/api/pms/admin/white/page/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 新增
export function whitePageAdd (val) {
  return request({
    url: '/api/pms/admin/white/page/add',
    method: 'post',
    data: val
  })
}
// 分页列表
export function whitePageList (val) {
  return request({
    url: `/api/pms/admin/white/page/list/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.searchWhitePageVO
  })
}
// 页码管理-------------------------------------------------------------------------
// 详情
export function pageNumberQueryPageNumberById (val) {
  return request({
    url: `/api/pms/admin/page/number/queryPageNumberById/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 新增
export function pageNumberAdd (val) {
  return request({
    url: '/api/pms/admin/page/number/add',
    method: 'post',
    data: val
  })
}
// 删除
export function pageNumberDelete (val) {
  return request({
    url: `/api/pms/admin/page/number/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 分页列表
export function pageNumberGetPageNumberList (val) {
  return request({
    url: `/api/pms/admin/page/number/getPageNumberList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.searchPageNumberVo
  })
}
// 页码样式列表
export function getPageNumberTypeList (val) {
  return request({
    url: '/api/pms/open/page/number/getPageNumberTypeList',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 编辑页码
export function pageNumberUpdate (val) {
  return request({
    url: '/api/pms/admin/page/number/update',
    method: 'put',
    data: val
  })
}
// 平台文档------------------------------------------------------------------------
// 分页列表
export function storeGetStoreList (val) {
  return request({
    url: `/api/pms/admin/store/getStoreList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.searchStoreVo
  })
}

// ATG-模板组管理(后台接口)---------------------------------------------------------------
// 通过尺寸组获取模板组列表
export function getGroupListByComposeSizeGroupId (val) {
  return request({
    url: `/api/pms/admin/group/getGroupListByComposeSizeGroupId/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.data
  })
}

// 通过SKU获取模板组列表
export function getGroupListBySkuId (val) {
  return request({
    // url: `/api/pms/admin/group/getGroupListBySkuId/${val.pageNum}/${val.pageSize}`,
    url: `/api/pms/admin/group/getGroupListBySkuId/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.data
  })
}

// SKU设置默认设计模板组
export function setDefaultTemplateGroup (val) {
  return request({
    url: '/api/pms/admin/group/setDefaultTemplateGroup',
    method: 'post',
    params: val
  })
}

// SKU设置默认下载模板组
export function setDownloadTemplateGroup (val) {
  return request({
    url: '/api/pms/admin/group/setDownloadTemplateGroup',
    method: 'post',
    data: val
  })
}

// sku关联模板组
export function groupSkuRelateGroup (val) {
  return request({
    url: '/api/pms/admin/group/skuRelateGroup',
    method: 'post',
    data: val
  })
}

// 模板组归属
export function groupGetStoreListByGroupId (val) {
  return request({
    url: `/api/pms/admin/group/getStoreListByGroupId/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.searchStoreVo
  })
}
// 收选片模板删除校验
export function getSkuByTemplateId (val) {
  return request({
    url: `/api/pms/admin/sku/getSkuByTemplateId/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 删除
export function groupBatchRemove (val) {
  return request({
    url: '/api/pms/admin/group/batchRemove',
    method: 'post',
    data: val
  })
}
// 关联
export function groupRelate (val) {
  return request({
    url: '/api/pms/admin/group/relate',
    method: 'post',
    data: val
  })
}
// 编辑模板主图
export function updateSkuMainImage (val) {
  return request({
    url: '/api/pms/admin/group/updateSkuMainImage',
    method: 'post',
    data: val
  })
}
// 模板组日志
export function groupGetGroupOperationLog (val) {
  return request({
    url: `/api/pms/admin/group/getGroupOperationLog/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.groupOperationLogVo
  })
}
// 审核
export function groupAuditGroup (val) {
  return request({
    url: '/api/pms/admin/group/auditGroup',
    method: 'post',
    data: val
  })
}
// 新增
export function groupAdd (val) {
  return request({
    url: '/api/pms/admin/group/add',
    method: 'post',
    data: val
  })
}
// 编辑模板组
export function groupUpdate (val) {
  return request({
    url: '/api/pms/admin/group/update',
    method: 'put',
    data: val
  })
}
// 模板数量
export function getTemplateListByGroupId (val) {
  return request({
    url: `/api/pms/admin/group/getTemplateListByGroupId/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 编辑关联关系
export function updateGroupXrefTemplate (val) {
  return request({
    url: '/api/pms/admin/group/updateGroupXrefTemplate',
    method: 'put',
    data: val
  })
}
// 详情
export function groupQueryGroupById (val) {
  return request({
    url: `/api/pms/admin/group/queryGroupById/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 分页列表
export function groupGetGroupList (val) {
  return request({
    url: `/api/pms/admin/group/getGroupList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.searchGroupVo
  })
}
// 添加关联分页列表
export function getGroupListForSkuRelate (val) {
  return request({
    url: `/api/pms/admin/group/getGroupListForSkuRelate/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.searchGroupVo
  })
}

// 模板管理（后台接口）---------------------------------------------------------
// 删除
export function templateBatchRemove (val) {
  return request({
    url: '/api/pms/admin/template/batchRemove',
    method: 'post',
    data: val
  })
}
// 模板审核
export function templateAuditTemplate (val) {
  return request({
    url: '/api/pms/admin/template/auditTemplate',
    method: 'post',
    data: val
  })
}
// 分页列表
export function templateGetTemplateList (val) {
  return request({
    url: `/api/pms/admin/template/getTemplateList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.searchTemplateVo
  })
}
// 详情
export function templateQueryTemplateById (val) {
  return request({
    url: `/api/pms/admin/template/queryTemplateById/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 模板性质管理-------------------------------------------------------------------
// 列表
export function propertyGetPropertyList (val) {
  return request({
    url: '/api/pms/open/property/getPropertyList',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 版式管理（后台接口）-----------------------------------------------------------------
// 删除
export function layoutBatchRemove (val) {
  return request({
    url: '/api/pms/admin/layout/batchRemove',
    method: 'post',
    data: val
  })
}
// 设置显示
export function ayoutSetShow (val) {
  return request({
    url: '/api/pms/admin/layout/setShow',
    method: 'post',
    data: val
  })
}
// 详情
export function layoutQueryLayoutById (val) {
  return request({
    url: `/api/pms/admin/layout/queryLayoutById/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 分页列表
export function layoutGetLayoutList (val) {
  return request({
    url: `/api/pms/admin/layout/getLayoutList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.searchLayoutVo
  })
}
// sku管理----------------------------------------------------

// 删除
export function skuDelete (val) {
  return request({
    url: `/api/pms/admin/sku/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 模板组关联列表
export function skuListAssociate (val) {
  return request({
    url: `/api/pms/admin/sku/list/associate/${val.composeSizeGroupId}/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.templateSearchSkuVO
  })
}
// 关联模板组
export function skuAssociateTemplateGroup (val) {
  return request({
    url: '/api/pms/admin/sku/associate/template/group',
    method: 'post',
    data: val
  })
}
// 列表
export function skuList (val) {
  return request({
    url: `/api/pms/admin/sku/list/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 新增
export function skuAdd (val) {
  return request({
    url: '/api/pms/admin/sku/add',
    method: 'post',
    data: val
  })
}
// 更新
export function skuUpdate (val) {
  return request({
    url: `/api/pms/admin/sku/update/${val.skuId}`,
    method: 'put',
    data: val.editSkuVo
  })
}
// 名称可用
export function skuUsable (val) {
  return request({
    url: '/api/pms/admin/sku/usable',
    method: 'post',
    params: val
  })
}
// SKU组管理-------------------------------------------------
// 统计sku组
export function skuGroupCounter (val) {
  return request({
    url: `/api/pms/admin/sku/group/counter/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 新增-1
export function skuGroupAdd (val) {
  return request({
    url: '/api/pms/admin/sku/group/add',
    method: 'post',
    data: val
  })
}
// 新增-2
export function skuGroupAddDetail (val) {
  return request({
    url: '/api/pms/admin/sku/group/addDetail',
    method: 'post',
    data: val
  })
}
// 新增通货
export function skuGroupAddCurrency (val) {
  return request({
    url: '/api/pms/admin/sku/group/add/currency',
    method: 'post',
    data: val
  })
}
// 添加套系通货
export function skuGroupAddSeriesCurrency (val) {
  return request({
    url: '/api/pms/admin/sku/group/add/series/currency',
    method: 'post',
    data: val
  })
}
// 添加套系
export function skuGroupSeriesAdd (val) {
  return request({
    url: '/api/pms/admin/sku/group/series/add',
    method: 'post',
    data: val
  })
}
// 列表
export function skuGroupList (val) {
  return request({
    url: `/api/pms/admin/sku/group/list/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.skuVo
  })
}
// 列表bySpuId
export function skuGroupListBySpuId (val) {
  return request({
    url: `/api/pms/admin/sku/group/list/${val.spuId}/${val.pageNum}/${val.pageSize}`,
    method: 'post'
  })
}
// 平台关联sku组(关联|未关联)
export function skuGroupAssociate (val) {
  return request({
    url: `/api/pms/admin/sku/group/associate/${val.flag}/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.platSkuGroupVo
  })
}
// 上下架
export function skuGroupSale (val) {
  return request({
    url: `/api/pms/admin/sku/group/sale/${val.skuGroupId}/${val.status}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 批量上下架
export function skuGroupSaleAll (val) {
  return request({
    url: `/api/pms/admin/sku/group/sale/${val.status}`,
    method: 'post',
    data: val.skuGroupIdList
  })
}
// 操作日志
export function skuGroupLog (val) {
  return request({
    url: `/api/pms/admin/sku/group/log/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 详情
export function skuGroupDetail (val) {
  return request({
    url: `/api/pms/admin/sku/group/detail/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更新套系
export function skuGroupUpdateSeries (val) {
  return request({
    url: `/api/pms/admin/sku/group/update/series/${val.skuGroupId}/${val.skuId}`,
    method: 'post',
    data: val.skuVo
  })
}
// 更新套系通货
export function updateSeriesCurrency (val) {
  return request({
    url: `/api/pms/admin/sku/group/update/series/currency/${val.skuGroupId}`,
    method: 'post',
    data: val.addSeriesCurrencySkuGroupVO
  })
}
// 更新
export function skuGroupUpdate (val) {
  return request({
    url: `/api/pms/admin/sku/group/update/${val.skuGroupId}`,
    method: 'put',
    data: val.editSkuGroupVo
  })
}
// 更新通货
export function skuGroupUpdateCurrency (val) {
  return request({
    url: `/api/pms/admin/sku/group/update/currency/${val.skuGroupId}`,
    method: 'post',
    data: val.simpleCurrencySkuGroupVO
  })
}
// 审核
export function skuGroupAudit (val) {
  return request({
    url: `/api/pms/admin/sku/group/audit/${val.skuGroupId}/${val.status}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 删除
export function skuGroupDelete (val) {
  return request({
    url: `/api/pms/admin/sku/group/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 产品管理----------------------------------------------------
// 查询是否有白页
export function spuHasWhitePage (val) {
  return request({
    url: `/api/pms/admin/spu/hasWhitePage/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 删除
export function spuDelete (val) {
  return request({
    url: `/api/pms/admin/spu/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更新
export function spuUpdate (val) {
  return request({
    url: `/api/pms/admin/spu/update/${val.spuId}`,
    method: 'put',
    data: val.spuVO
  })
}
// 详情
export function spuGet (val) {
  return request({
    url: `/api/pms/admin/spu/get/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 名称可用
export function spuUsable (val) {
  return request({
    url: '/api/pms/admin/spu/usable',
    method: 'post',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 新增单品
export function spuAdd (val) {
  return request({
    url: '/api/pms/admin/spu/add',
    method: 'post',
    data: val
  })
}
// 分页列表
export function spuList (val) {
  return request({
    url: `/api/pms/admin/spu/list/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.spuVO
  })
}
// 新增套系
export function spuSeriesAdd (val) {
  return request({
    url: '/api/pms/admin/spu/series/add',
    method: 'post',
    data: val
  })
}
// 更新套系
export function spuSeriesUpdate (val) {
  return request({
    url: `/api/pms/admin/spu/series/update/${val.spuId}`,
    method: 'put',
    data: val.seriesVo
  })
}
// 产品性质管理----------------------------------------------
// 新增
export function propertyAdd (val) {
  return request({
    url: '/api/pms/admin/spu/property/add',
    method: 'post',
    data: val
  })
}
// 详情
export function propertyDetail (val) {
  return request({
    url: `/api/pms/admin/spu/property/detail/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 列表
export function propertyList () {
  return request({
    url: '/api/pms/admin/spu/property/list',
    method: 'get',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded'
    }
  })
}
// 产品属性管理------------------------------------------------
// 删除
export function dictDelete (val) {
  return request({
    url: `/api/pms/admin/spu/dict/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 名称重复
export function dictUsable (val) {
  return request({
    url: '/api/pms/admin/spu/dict/usable',
    method: 'post',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 新增
export function dictAdd (val) {
  return request({
    url: '/api/pms/admin/spu/dict/add',
    method: 'post',
    data: val
  })
}
// 查询下级
export function dictQueryByPid (val) {
  return request({
    url: `/api/pms/admin/spu/dict/queryByPid/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 分页查询下级
export function dictQueryByPidPage (val) {
  return request({
    url: `/api/pms/admin/spu/dict/queryByPid/${val.parentId}/${val.pageNum}/${val.pageSize}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 详情
export function dictGet (val) {
  return request({
    url: `/api/pms/admin/spu/dict/get/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更新
export function dictUpdate (val) {
  return request({
    url: `/api/pms/admin/spu/dict/update/${val.dictId}`,
    method: 'put',
    data: val.dictVo
  })
}
// 列表
export function dictListNoPaging (val) {
  return request({
    url: `/api/pms/admin/spu/dict/list/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 分页列表
export function dictList (val) {
  return request({
    url: `/api/pms/admin/spu/dict/list/${val.pageNum}/${val.pageSize}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 前台展示
export function dictShow (val) {
  return request({
    url: `/api/pms/admin/spu/dict/show/${val.dictId}/${val.isShow}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 产品类管理--------------------------------------------------
// 详情
export function categoryGet (val) {
  return request({
    url: `/api/pms/admin/category/get/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 检查名称重复
export function categoryUsable (val) {
  return request({
    url: '/api/pms/admin/category/usable',
    method: 'post',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 新增
export function categoryAdd (val) {
  return request({
    url: '/api/pms/admin/category/add',
    method: 'post',
    data: val
  })
}
// 查询子类
export function categoryQuerySubs (val) {
  return request({
    url: `/api/pms/admin/category/querySubs/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更新
export function categoryUpdate (val) {
  return request({
    url: `/api/pms/admin/category/update/${val.categoryId}`,
    method: 'put',
    data: val.categoryVo
  })
}
// 列表
export function categoryList () {
  return request({
    url: '/api/pms/admin/category/list',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 查询所有子类
export function queryAllSubs (val) {
  return request({
    url: `/api/pms/admin/category/queryAllSubs/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 分页列表
export function categoryListPaging (val) {
  return request({
    url: `/api/pms/admin/category/list/${val.pageNum}/${val.pageSize}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 删除
export function categoryDelete (val) {
  return request({
    url: `/api/pms/admin/category/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function categoryDeleteAdmin (val) {
  return request({
    url: `/api/pms/admin/pos/category/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 自定义分类 --------------------------------------------------
// 列表
export function customCategoryList () {
  return request({
    url: '/api/pms/admin/bridalCategory/list',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 新增
export function customCategoryAdd (val) {
  return request({
    url: '/api/pms/admin/bridalCategory/add',
    method: 'post',
    data: val
  })
}

// 详情
export function customCategoryGet (val) {
  return request({
    url: `/api/pms/admin/bridalCategory/get/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 检查名称重复
export function customCategoryUsable (val) {
  return request({
    url: '/api/pms/admin/bridalCategory/usable',
    method: 'post',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 查询子类
export function customCategoryQuerySubs (val) {
  return request({
    url: `/api/pms/admin/bridalCategory/querySubs/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更新
export function customCategoryUpdate (val) {
  return request({
    url: `/api/pms/admin/bridalCategory/update/${val.categoryId}`,
    method: 'put',
    data: val.categoryVo
  })
}

// 删除
export function customCategoryDelete (val) {
  return request({
    url: `/api/pms/admin/bridalCategory/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 查询关联的产品
export function customGetProductes (val, categoryId) {
  return request({
    url: `/api/pms/admin/bridalCategory/getSpuListByCategoryId/${val.pageNum}/${val.pageSize}/${categoryId}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 查询所有关联产品的id
export function customGetAllProductIds (categoryId) {
  return request({
    url: `/api/pms/admin/bridalCategory/getSpuIdListByCategoryId/${categoryId}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 设为推荐

export function customCategorySetRecommend (categoryId) {
  return request({
    url: `/api/pms/admin/bridalCategory/setRecommend/${categoryId}`,
    method: 'put',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 关联产品
export function customCategoryAddProduct (categoryId, productids) {
  return request({
    url: `/api/pms/admin/bridalCategory/associateSpu/${categoryId}`,
    method: 'put',
    data: {
      spuId: productids
    }
  })
}

// 取消关联产品
export function customCategoryCancelProduct (categoryId, productids) {
  return request({
    url: `/api/pms/admin/bridalCategory/disassociateSpu/${categoryId}`,
    method: 'put',
    data: {
      spuId: productids
    }
  })
}

// 合成尺寸管理 --------------------------------------------------
// 列表
export function sizeList (groupId) {
  return request({
    url: `/api/pms/admin/compose/size/list/${groupId}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 分页列表
export function sizeListPaging (val) {
  return request({
    url: `/api/pms/admin/compose/size/list/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.data
  })
}
// 详情
export function sizeDetail (val) {
  return request({
    url: `/api/pms/admin/compose/size/detail/${val}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 名称可用
export function composeSizeUsable (val) {
  return request({
    url: '/api/pms/admin/compose/size/usable',
    method: 'post',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 新增
export function composeSizeAdd (val) {
  return request({
    url: '/api/pms/admin/compose/size/add',
    method: 'post',
    data: val
  })
}
// 更新
export function composeSizeUpdate (val) {
  return request({
    url: `/api/pms/admin/compose/size/update/${val.sizeId}`,
    method: 'put',
    data: val.composeSizeVo
  })
}
// 更新页面名称
export function composeSizeUpdatePage (val) {
  return request({
    url: `/api/pms/admin/compose/size/update/${val.sizeId}/${val.pageNameId}`,
    method: 'put',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 合成尺寸类型管理------------------------------------------------
// 列表
export function composeTypeList () {
  return request({
    url: '/api/pms/admin/compose/type/list',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 详情
export function composeTypeDetail (val) {
  return request({
    url: `/api/pms/admin/compose/type/detail/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 名称可用
export function composeTypeUsable (val) {
  return request({
    url: '/api/pms/admin/compose/type/usable',
    method: 'post',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 新增
export function composeTypeAdd (val) {
  return request({
    url: '/api/pms/admin/compose/type/add',
    methods: 'post',
    data: val
  })
}
// 更新
export function composeTypeUpdate (val) {
  return request({
    url: `/api/pms/admin/compose/type/update/${val.typeId}`,
    methods: 'put',
    data: val.composeTypeVo
  })
}
// 分页列表
export function composeTypeListPaging (val) {
  return request({
    url: `/api/pms/admin/compose/type/list/${val.pageNum}/${val.pageSize}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 删除
export function composeSizeDelete (val) {
  return request({
    url: `/api/pms/admin/compose/size/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 出血管理----------------------------------------------------------
// 详情
export function bleedDetail (val) {
  return request({
    url: `/api/pms/admin/bleed/detail/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 名称是否可用
export function bleedUsable (val) {
  return request({
    url: '/api/pms/admin/bleed/usable',
    method: 'post',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更新
export function bleedUpdate (val) {
  return request({
    url: `/api/pms/admin/bleed/update/${val.bleedId}`,
    method: 'put',
    data: val.spuBleedVo
  })
}
// 新增
export function bleedAdd (val) {
  return request({
    url: '/api/pms/admin/bleed/add',
    method: 'post',
    data: val
  })
}
// 列表
export function bleedList () {
  return request({
    url: '/api/pms/admin/bleed/list',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 分页列表
export function bleedListPaging (val) {
  return request({
    url: `/api/pms/admin/bleed/list/${val.pageNum}/${val.pageSize}`,
    method: 'get',
    params: { bleedName: val.bleedName },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 主题管理------------------------------------------------------
// 分页列表
export function sampleList (val) {
  return request({
    url: `/api/pms/admin/sample/list/${val.pageNum}/${val.pageSize}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 列表
export function sampleListNoPaging () {
  return request({
    url: '/api/pms/admin/sample/list',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 新增
export function sampleAdd (val) {
  return request({
    url: '/api/pms/admin/sample/add',
    method: 'post',
    params: { themeName: val }
  })
}
// 删除
export function sampleDelete (val) {
  return request({
    url: `/api/pms/admin/sample/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更新
export function sampleUpdate (val) {
  return request({
    url: `/api/pms/admin/sample/update/${val.themeId}`,
    method: 'put',
    params: { themeName: val.themeName },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 名称可用
export function sampleUsable (val) {
  return request({
    url: '/api/pms/admin/sample/usable',
    method: 'post',
    params: val
  })
}
// 合成区管理------------------------------------------------------
// 删除
export function areaDelete (val) {
  return request({
    url: `/api/pms/admin/compose/area/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 名称可用
export function areaUsable (val) {
  return request({
    url: '/api/pms/admin/compose/area/usable',
    method: 'post',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 详情
export function areaDetail (val) {
  return request({
    url: `/api/pms/admin/compose/area/detail/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更新
export function areaUpdate (val) {
  return request({
    url: `/api/pms/admin/compose/area/update/${val.areaId}`,
    method: 'put',
    data: val.areaLineVo
  })
}
// 新增
export function areaAdd (val) {
  return request({
    url: '/api/pms/admin/compose/area/add',
    method: 'post',
    data: val
  })
}
// 列表
export function areaList () {
  return request({
    url: '/api/pms/admin/compose/area/list',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 分页列表
export function areaListPaging (val) {
  return request({
    url: `/api/pms/admin/compose/area/list/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    params: val.areaName,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 机器码管理-------------------------------------------------------------------------------------------------------------
// 新增
export function machineCodeAdd (val) {
  return request({
    url: '/api/pms/admin/machine/code/add',
    method: 'post',
    data: val
  })
}
// 详情
export function codeDetail (val) {
  return request({
    url: `/api/pms/admin/machine/code/detail/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 列表
export function machineCodeListNoPage (val) {
  return request({
    url: '/api/pms/admin/machine/code/list',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 分页列表
export function machineCodeList (val) {
  return request({
    url: `/api/pms/admin/machine/code/list/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    params: val.machineCodeName,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更新
export function machineCodeUpdate (val) {
  return request({
    url: `/api/pms/admin/machine/code/update/${val.id}`,
    method: 'put',
    data: val.machineCodeVO
  })
}
// 名称可用
export function machineCodeUsable (val) {
  return request({
    url: '/api/pms/admin/machine/code/usable',
    method: 'post',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 删除
export function machineCodeDelete (val) {
  return request({
    url: `/api/pms/admin/machine/code/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 特殊价格管理----------------------------------------------------------------------------------------------------------------
// 删除
export function skuSpecialPriceDelete (val) {
  return request({
    url: `/api/pms/admin/sku/special/price/delete/${val.skuGroupId}/${val.storeId}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 删除
export function skuSpecialPriceDeleteBySpecialId (val) {
  return request({
    url: `/api/pms/admin/sku/special/price/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 分页列表
export function skuSpecialList (val) {
  return request({
    url: `/api/pms/admin/sku/special/price/list/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.specialVo
  })
}
// 新增
export function skuSpecialAdd (val) {
  return request({
    url: '/api/pms/admin/sku/special/price/add',
    method: 'post',
    data: val
  })
}
// 加盟店列表
export function skuSpecialStoreList (val) {
  return request({
    url: `/api/pms/admin/sku/special/price/list/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 详情
export function skuSpecialGet (val) {
  return request({
    url: `/api/pms/admin/sku/special/price/get/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 审核
export function skuSpecialAudit (val) {
  return request({
    url: `/api/pms/admin/sku/special/price/audit/${val.specialId}/${val.status}`,
    method: 'put',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更新
export function skuSpecialUpdate (val) {
  return request({
    url: `/api/pms/admin/sku/special/price/update/${val.specialId}`,
    method: 'put',
    data: val.specialPriceVo
  })
}
// 尺寸组类---------------------------------------------------------------------------------------------------------------
// 删除
export function sizeGroupCategoryDelete (val) {
  return request({
    url: `/api/pms/admin/compose/size/group/category/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 列表
export function groupCategoryList () {
  return request({
    url: '/api/pms/admin/compose/size/group/category/list',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 分页列表
export function groupCategoryListPage (val) {
  return request({
    url: `/api/pms/admin/compose/size/group/category/list/${val.pageNum}/${val.pageSize}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 新增
export function composeGroupCategoryAdd (val) {
  return request({
    url: '/api/pms/admin/compose/size/group/category/add',
    method: 'post',
    params: val
  })
}
// 更新
export function groupCategoryUpdate (val) {
  return request({
    url: `/api/pms/admin/compose/size/group/category/update/${val.id}`,
    method: 'put',
    params: val.params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 名称可用
export function groupCategoryUsable (val) {
  return request({
    url: '/api/pms/admin/compose/size/group/category/usable',
    method: 'post',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 尺寸组-------------------------------------------------------------------------------------------------
// 尺寸组设置默认设计模板组
export function sizeGroupSetDefaultTemplateGroup (val) {
  return request({
    url: '/api/pms/admin/compose/size/group/setDefaultTemplateGroup',
    method: 'post',
    params: val
  })
}
// 尺寸组设置默认下载模板组
export function sizeGroupSetDownloadTemplateGroup (val) {
  return request({
    url: '/api/pms/admin/compose/size/group/setDownloadTemplateGroup',
    method: 'post',
    data: val
  })
}
// 新建
export function composeGroupAdd (val) {
  return request({
    url: '/api/pms/admin/compose/size/group/add',
    method: 'post',
    data: val
  })
}
// 列表
export function groupList () {
  return request({
    url: '/api/pms/admin/compose/size/group/list',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 分页列表
export function groupListPageing (val) {
  return request({
    url: `/api/pms/admin/compose/size/group/list/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.data
  })
}
// 详情
export function composeGroupDetail (val) {
  return request({
    url: `/api/pms/admin/compose/size/group/detail/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 名称是否可用
export function composeGroupUsable (val) {
  return request({
    url: '/api/pms/admin/compose/size/group/usable',
    method: 'post',
    params: val
  })
}
// 删除
export function groupDelete (val) {
  return request({
    url: `/api/pms/admin/compose/size/group/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 条码管理---------------------------------------------------
// 分页列表
export function barListPage (val) {
  return request({
    url: `/api/pms/admin/bar/list/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.codeListVO
  })
}
// 列表
export function barList (val) {
  return request({
    url: '/api/pms/admin/bar/list',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 详情
export function barDetail (val) {
  return request({
    url: `/api/pms/admin/bar/detail/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更新
export function barUpdate (val) {
  return request({
    url: `/api/pms/admin/bar/update/${val.barCodeId}`,
    method: 'put',
    data: val.data
  })
}
// 新增
export function barAdd (val) {
  return request({
    url: '/api/pms/admin/bar/add',
    method: 'post',
    data: val
  })
}
// 名称是否可用
export function barUsable (val) {
  return request({
    url: '/api/pms/admin/bar/usable',
    method: 'post',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 删除
export function barDelete (val) {
  return request({
    url: `/api/pms/admin/bar/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 页面名称管理------------------------------------------------------------------------------------------------
// 新增
export function pageNameAdd (val) {
  return request({
    url: '/api/pms/admin/spu/page/name/add',
    method: 'post',
    data: val
  })
}
// 列表
export function pageNameList (val) {
  return request({
    url: '/api/pms/admin/spu/page/name/list',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 列表by尺寸组id
export function pageNameListById (val) {
  return request({
    url: `/api/pms/admin/spu/page/name/list/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更新模版性质
export function updateTemplateProperty (val) {
  return request({
    url: `/api/pms/admin/spu/page/name/update/template/property/${val.pageId}`,
    method: 'put',
    params: val.params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 分页列表
export function pageNameListPage (val) {
  return request({
    url: `/api/pms/admin/spu/page/name/list/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.searchPageNameVo
  })
}
// 删除
export function pageNameDelete (val) {
  return request({
    url: `/api/pms/admin/spu/page/name/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 页面类型管理------------------------------------------------------------------------------------------------
// 列表
export function pageTypeList (val) {
  return request({
    url: '/api/pms/admin/spu/page/type/list',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 产品推送---------------------------------------------------------------
// 新增
export function storeSpuAdd (val) {
  return request({
    url: `/api/pms/admin/store/spu/add/${val.spuId}`,
    method: 'post',
    params: { storeIdSet: val.storeIdSet },
    // params: val.storeIdSet,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 列表
export function storeSpuList (val) {
  return request({
    url: `/api/pms/admin/store/spu/list/${val.spuId}/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.searchStoreVO
  })
}
// 列表
export function storeSpuRemove (val) {
  return request({
    url: `/api/pms/admin/store/spu/remove/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 字典管理---------------------------------------------------------------
// 属性列表
export function dictionaryList (dictKey) {
  return request({
    url: `/api/pms/admin/sys/dictionary/list/${dictKey}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 属性KEY列表
export function dictionaryKeyList (val) {
  return request({
    url: '/api/pms/admin/sys/dictionary/list/key',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 添加属性
export function dictionarySave (dictKey, dictValue, dictCode) {
  return request({
    url: `/api/pms/admin/sys/dictionary/save/key?dictKey=${dictKey}&dictValue=${dictValue}&dictCode=${dictCode}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 修改属性
export function dictionaryUpdate (val) {
  return request({
    url: `/api/pms/admin/sys/dictionary/update/key?dictValue=${val.dictValue}&id=${val.id}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 修改属性
export function getExample (templateId) {
  return request({
    url: `/api/pms/tpl/template/getExample/${templateId}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 删除属性
export function dictionaryRemove (id) {
  return request({
    url: `/api/pms/admin/sys/dictionary/remove/${id}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 运费模板管理
// 列表
export function moduleList (val) {
  return request({
    url: `/api/pms/admin/express/module/list/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.vo
  })
}
// 新增
export function moduleAdd (val) {
  return request({
    url: '/api/pms/admin/express/module/add',
    method: 'post', // 请求方式
    data: val
  })
}
// 编辑
export function moduleEdit (val) {
  return request({
    url: '/api/pms/admin/express/module/edit',
    method: 'post', // 请求方式
    data: val
  })
}
// 详情
export function moduleDetail (val) {
  return request({
    url: `/api/pms/admin/express/module/detail/${val}`,
    method: 'get'// 请求方式
  })
}
// 删除-根据运费计算id删除
export function deleteByModuleFeeId (val) {
  return request({
    url: `/api/pms/admin/express/module/deleteByModuleFeeId/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 删除-根据运费模板id删除
export function deleteByModuleId (val) {
  return request({
    url: `/api/pms/admin/express/module/deleteByModuleId/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 满减
// 列表
export function getActivityList (val) {
  return request({
    url: `/api/pms/admin/discount/activity/getActivityList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.searchStoreVO
  })
}
// 新增
export function activityAdd (val) {
  return request({
    url: '/api/pms/admin/discount/activity/add',
    method: 'post',
    data: val
  })
}
// 编辑
export function activityEdit (val) {
  return request({
    url: '/api/pms/admin/discount/activity/update',
    method: 'put',
    data: val
  })
}
// 详情
export function getActivityById (id) {
  return request({
    url: `/api/pms/discount/activity/getActivityById/${id}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 删除
export function activityDelete (val) {
  return request({
    url: `/api/pms/admin/discount/activity/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 产品列表
export function getSpuListForActivity (val) {
  return request({
    url: '/api/pms/admin/discount/activity/getSpuListForActivity',
    method: 'post',
    data: val
  })
}
// 设为失效
export function setExpired (id) {
  return request({
    url: `/api/pms/admin/discount/activity/setExpired/${id}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 根据产品id获取进行中活动详情
export function getProgressingActivityBySpuId (id) {
  return request({
    url: `/api/pms/discount/activity/getProgressingActivityBySpuId/${id}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// App模块
// 模块列表
export function appModuleList (val) {
  return request({
    url: '/api/pms/app-module/list',
    method: 'post',
    data: val
  })
}
// 修改名称
export function updateModuleName (val) {
  return request({
    url: '/api/pms/app-module/updateName',
    method: 'post',
    data: val
  })
}
// 排序
export function updateModuleInfo (val) {
  return request({
    url: '/api/pms/app-module/updateInfo',
    method: 'post',
    data: val
  })
}
// banner新增
export function appBannerSave (val) {
  return request({
    url: '/api/pms/app-banner/save',
    method: 'post',
    data: val
  })
}
// banner查询
export function appBannerList (val) {
  return request({
    url: '/api/pms/app-banner/list',
    method: 'post'
  })
}
// 根据ID查询banner信息
export function getBannerInfoById (id) {
  return request({
    url: `/api/pms/app-banner/getInfoById?id=${id}`,
    method: 'post'
  })
}
// banner编辑
export function updateBannerById (val) {
  return request({
    url: '/api/pms/app-banner/updateById',
    method: 'post',
    data: val
  })
}
// banner排序
export function updateBannerInfo (val) {
  return request({
    url: '/api/pms/app-banner/updateInfo',
    method: 'post',
    data: val
  })
}
// banner删除
export function deleteBannerById (id) {
  return request({
    url: `/api/pms/app-banner/deleteById?id=${id}`,
    method: 'post'
  })
}
// 推荐产品
// 新增
export function appRecmendSave (val) {
  return request({
    url: '/api/pms/app-recmend/save',
    method: 'post',
    data: val
  })
}
// 查询
export function appRecmendList (val) {
  return request({
    url: '/api/pms/app-recmend/list',
    method: 'post',
    data: val
  })
}
// 编辑
export function updateRecmendById (val) {
  return request({
    url: '/api/pms/app-recmend/updateById',
    method: 'post',
    data: val
  })
}
// 排序
export function updateRecmendInfo (val) {
  return request({
    url: '/api/pms/app-recmend/updateInfo',
    method: 'post',
    data: val
  })
}
// 删除
export function deleteRecmendById (id) {
  return request({
    url: `/api/pms/app-recmend/deleteById?id=${id}`,
    method: 'post'
  })
}
// 根据id查询推荐产品信息
export function getInfoRecmendById (id) {
  return request({
    url: `/api/pms/app-recmend/getInfoById?id=${id}`,
    method: 'post'
  })
}
// 根据类型获取关联信息
export function getRelatesInfo (val) {
  return request({
    url: '/api/pms/wx/spu/getRelatesInfo',
    method: 'post',
    data: val
  })
}
// 新增样片文件
export function saveSampleImage (val) {
  return request({
    url: '/api/pms/admin/sku/sample/saveSampleImage',
    method: 'post',
    data: val
  })
}
// 预览样片文件
export function previewSampleImage (val) {
  return request({
    url: `/api/pms/admin/sku/sample/previewSampleImage/${val.skuGroupId}/${val.id}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 模糊查询产品
export function spuListSpu (val) {
  return request({
    url: `/api/pms/admin/sku/sample/list/${val.storeId}/${val.spuName}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 详情
export function storeSpuQuery (val) {
  return request({
    url: `/api/pms/open/spu/query/${val}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 显示尺寸列表
export function associateList (val) {
  return request({
    url: '/api/pms/admin/compose/display/size/list', // 接口
    method: 'post', // 请求方式
    data: val
  })
}
// 分页列表
export function sizeListPage (val) {
  return request({
    url: `/api/pms/admin/compose/display/size/list/${val.pageNum}/${val.pageSize}`, // 接口
    method: 'post', // 请求方式
    data: val.data
  })
}
// 显示尺寸新增
export function associateAdd (val) {
  return request({
    url: '/api/pms/admin/compose/display/size/add', // 接口
    method: 'post', // 请求方式
    data: val
  })
}
// 线上产品管理-产品-删除
export function deleteSize (val) {
  return request({
    url: `/api/pms/admin/compose/display/size/delete/${val}`, // 接口
    method: 'delete', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更新
export function sizeUpdate (val) {
  return request({
    url: `/api/pms/admin/compose/display/size/update/${val.categoryId}`, // 接口
    method: 'put', // 请求方式
    data: val.data
  })
}
// 详情
export function showSizeDetail (val) {
  return request({
    url: `/api/pms/admin/compose/display/size/detail/${val}`,
    method: 'post'// 请求方式
  })
}
// 尺寸组关联显示尺寸
export function relevanceAssociate (val) {
  return request({
    url: '/api/pms/admin/compose/display/size/associate', // 接口
    method: 'post', // 请求方式
    data: val
  })
}

// ======= 云底片管理  start=======

// 获取云底片列表
export function getCloudFilmList (val) {
  return request({
    url: `/api/pms/photo/cloud/getPhotoLibraryList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.vo
  })
}

// ======= 云底片管理  end=======

// ======= 预约拍摄管理  start=======
// 获取分页列表
export function getAppointmentShootList (val) {
  return request({
    url: `/api/pms/yy/appointmentShoot/list/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.vo
  })
}

// ======= 预约拍摄管理  end=======

export function getHomeDecoration (storeId) {
  return request({
    url: `/api/pms/open/video/season/homePage/queryById/${storeId}?origin=UNT`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 获取分类列表
export function getClassificationList (storeId) {
  return request({
    url: `/api/pms/yy/packageClassification/getClassifications/${storeId}/0`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 投诉反馈
export function videoSeasonFeedbackList (val) {
  return request({
    url: `/api/pms/pms/videoSeasonFeedback/list/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.storeVo
  })
}
// 详情
export function videoSeasonFeedbackInfo (val) {
  return request({
    url: `/api/pms/pms/videoSeasonFeedback/getInfo/${val}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 复制产品
export function copySpu (val) {
  return request({
    url: `/api/pms/admin/spu/copySpu/${val}`,
    method: 'put'
  })
}
